import { ListRenderItem } from "@shopify/flash-list";
import { ReactionUserViewFragmentFragment } from "src/api/graphql/__generated__/graphql";
import ReactionUserItem from "../components/ReactionUserItem";

const renderReactionUserItem: ListRenderItem<ReactionUserViewFragmentFragment> = ({ item }) => {
	return <ReactionUserItem reactionUser={item} />;
};
export default renderReactionUserItem;
